import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "About", href: "#about" },
  { label: "Features", href: "#features" },
  { label: "Vision", href: "#vision" },
  { label: "Team", href: "#team" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50"
      data-testid="navbar"
    >
      <div
        className={`mx-auto max-w-7xl mt-3 md:mt-4 px-5 md:px-7 flex items-center justify-between h-16 rounded-full transition-colors duration-500 ${
          scrolled
            ? "backdrop-blur-xl bg-background/70 border border-border/60 shadow-sm"
            : "bg-transparent border border-transparent"
        }`}
        style={{ width: "calc(100% - 1.5rem)" }}
      >
        <a href="#top" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-primary">
            <span className="h-2.5 w-2.5 rounded-full bg-accent" />
          </span>
          <span className="font-serif text-2xl tracking-tight text-foreground">
            Kel<span className="italic text-primary">Calm</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://www.rajagiri.kelcalm.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-login-button"
          className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90 transition-colors duration-300"
        >
          Login
        </a>
      </div>
    </motion.header>
  );
};

export default Navbar;
